import { AuthLevel } from '../enums/auth-level.enum';

export class ApplicationUserAccess {
  public groupId: string;
  public authLevel: AuthLevel;

  constructor(backEndApplicationUserAccess: BackEndApplicationUserAccess) {
    if (backEndApplicationUserAccess) {
      this.groupId = backEndApplicationUserAccess.group_id;
      this.authLevel = backEndApplicationUserAccess.auth_level;
    }
  }
}

export class ApplicationUser {
  public email: string;
  public access: ApplicationUserAccess;

  constructor(backEndApplicationUser: BackEndApplicationUser) {
    if (backEndApplicationUser) {
      this.email = backEndApplicationUser.email;
      this.access = new ApplicationUserAccess(backEndApplicationUser.access);
    }
  }
}

//#region Backend
export interface BackEndApplicationUserList {
  application_id: string;
  users: BackEndApplicationUser[];
}

export interface BackEndApplicationUser {
  email: string;
  access: BackEndApplicationUserAccess;
}

export interface BackEndApplicationUserAccess {
  group_id: string;
  auth_level: AuthLevel;
}
//#endregion Backend
